import { FC, createContext, useContext, useMemo, useState } from "react";
import { alertType } from "./AlertUtils";

export interface IAlertMessage {
  show: boolean;
  type: alertType;
  description?: string;
}

export interface IAlertMessageContext {
  resetAlert: () => void;
  alert: IAlertMessage;
  successAlert: (description: string) => void;
  errorAlert: (description: string) => void;
  processingAlert: () => void;
}

const ctxAlertMessage = createContext<IAlertMessageContext>({
  resetAlert: () => {},
  alert: {
    show: false,
    description: "",
    type: alertType.NONE,
  },
  successAlert: () => {},
  errorAlert: () => {},
  processingAlert: () => {},
});

const AlertMessageContext: FC<any> = ({ children }) => {
  const [alert, setAlert] = useState<IAlertMessage>({
    show: false,
    description: "",
    type: alertType.NONE,
  });

  const resetAlert = () => {
    setAlert({ show: false, description: "", type: alertType.NONE });
  };

  const successAlert = (description: string) => {
    setAlert({ show: true, description, type: alertType.SUCCESS });
  };

  const errorAlert = (description: string) => {
    setAlert({ show: true, description, type: alertType.ERROR });
  };

  const processingAlert = () => {
    setAlert({
      show: true,
      description: "Procesando...",
      type: alertType.PROCESSING,
    });
  };

  const contextValue = useMemo(
    () => ({
      alert,
      resetAlert,
      successAlert,
      errorAlert,
      processingAlert,
    }),
    [alert, resetAlert, successAlert, errorAlert, processingAlert]
  );

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <ctxAlertMessage.Provider value={contextValue}>
      {children}
    </ctxAlertMessage.Provider>
  );
};

function useAlertMessageContext() {
  return useContext(ctxAlertMessage);
}

export { ctxAlertMessage, AlertMessageContext, useAlertMessageContext };
